import React from "react";
import "./ContactForm.css";

const ContactForm = () => {
  return (
    <div className="contact-page">
      <div className="contact-box">
        <h2 className="contact-title">Contact Me</h2>
        <p className="contact-subtitle">
          Let’s collaborate and build something amazing 🚀
        </p>

        <div className="contact-details">
          <p><strong>Freelance Work:</strong> Available for projects worldwide</p>
          <p>
            <strong>Email:</strong>{" "}
            <a
              href="mailto:adeel.hussain.siddiqui@gmail.com?subject=Freelance%20Work%20Inquiry&body=Hi%20Adeel,%0D%0A%0D%0AI%20am%20interested%20in%20working%20with%20you.%0D%0A%0D%0AThanks!"
              className="email-link"
            >
              adeel.hussain.siddiqui@gmail.com
            </a>
          </p>
          <p><strong>WhatsApp:</strong> +92 311 2081537</p>
          {/* <p><strong>Freelance Platforms:</strong> Fiverr | Upwork | LinkedIn</p>
          <p><strong>Skills:</strong> Web Development | MERN Stack | React | Node.js</p> */}
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
